import jwtAxios from "@richbeauty/services/auth/jwt-auth/jwt-api";
import { URL_API } from "@richbeauty/services/endpoint";
import useSWRMutation from "swr/mutation";

const convertFromLead = async (formData) => {
  return await jwtAxios.post(URL_API.CMS_USERS.CONVERT_FROM_LEAD, formData);
};

const useConvertFromLead = () => {
  const fetcher = (url, { arg }) => convertFromLead(arg);
  return useSWRMutation(URL_API.CMS_USERS.CONVERT_FROM_LEAD, fetcher);
};

export default useConvertFromLead;
